import { animate, animation, style } from '@angular/animations';

export const qaroniEnterFadeIn = animation([
  style({ opacity: 0 }),
  animate('{{time}}', style({ opacity: 1 })),
]);
